import React from 'react'
import './SignUp.css'
import { useSelector, useDispatch } from 'react-redux'
import { setCompanyName, setAddress } from 'redux/actions/'

export default function Login() {
  const dispatch = useDispatch()
  const { companyName, address } = useSelector(state => state.signup)
  return (
    <>
      <h1 style={{ textAlign: 'center', padding: '25px 0' }}>
        Who do you represent?
      </h1>
      <div>
        <label>Company Name</label>
        <input
          placeholder="Company Name"
          type="text"
          value={companyName}
          onChange={e => dispatch(setCompanyName(e.target.value))}
        />
        <label>Company Location</label>
        <input
          placeholder="Iraq / Erbil / Baharkah st."
          type="text"
          value={address}
          onChange={e => dispatch(setAddress(e.target.value))}
        />
      </div>
    </>
  )
}
